export enum UpdatedMatomoPeriod {
    Yearly,
    Monthly,
    Weekly,
    Last7,
    Last30,
    Last90,
    Daily
}
